import { useModalStore } from "@store/modal/modal";

export const Modals = () => {
  const state = useModalStore();

  return (
    <>
      {Object.entries(state.modals).map(([id, Modal]) => (
        <Modal key={id} />
      ))}
    </>
  );
};
